const PricingDataOptions = ["Lowest / BTI", "Low", "Medium", "High"];

export function getPricingDataOptions() {
  return PricingDataOptions.map((value) => ({
    value,
    name: value,
  }));
}
